import { Divider, Tooltip } from "@mui/joy";
import { Box, ClickAwayListener } from "@mui/material";
import { ReactElement, useState } from "react";
import { InstrumentPicker } from "./instrumentPicker";

/**
 *
 * @param root0
 * @param root0.onSelect
 * @param root0.myInstruments
 * @param root0.children
 * @param root0.sectionID
 * @param root0.familyID
 * @param root0.hideTitle
 * @param root0.hideToolbar
 * @param root0.height
 * @param root0.search
 * @param root0.clearInstruments
 * @returns {ReactElement} InstrumentsPopover page
 */
export function InstrumentsTooltip({
  myInstruments,
  onSelect,
  children,
  sectionID,
  familyID,
  hideTitle,
  height,
  hideToolbar,
  search,
  clearInstruments = false,
}: {
  onSelect: (i: number[] | null) => void;
  myInstruments?: boolean;
  children: ReactElement;
  sectionID?: number;
  familyID?: number;
  hideTitle?: boolean;
  hideToolbar?: boolean;
  height?: number;
  search?: boolean;
  clearInstruments?: boolean;
}) {
  const [open, setOpen] = useState(false);

  const handleOnSelect = (i) => {
    onSelect(i);
    setOpen(false);
  };

  return (
    <Tooltip
      arrow
      open={open}
      color="neutral"
      variant="outlined"
      title={
        <ClickAwayListener
          onClickAway={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setOpen(false);
          }}
        >
          <Box
            sx={{
              width: 400,
              maxHeight: 400,
              overflowY: "auto",
              height,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <InstrumentPicker
              myInstruments={myInstruments}
              hideToolbar={hideToolbar}
              hideTitle={hideTitle}
              sectionID={sectionID}
              familyID={familyID}
              onSelect={handleOnSelect}
              clearInstruments={clearInstruments}
            />
          </Box>
        </ClickAwayListener>
      }
    >
      <Box sx={{ display: "inline-block" }} onClick={() => setOpen(true)}>
        {children}
      </Box>
    </Tooltip>
  );
}
